module.exports = Cropper;